import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { blogPosts } from '../data/blogList';

const BlogPage = () => {
  return (
    <>
      <Helmet>
        <title>Blog Dépannage Informatique - Guides et Conseils | Excellence Informatique</title>
        <meta name="description" content="Découvrez nos articles experts sur le dépannage informatique, la formation et l'assistance technique à Nantes. Guides pratiques et conseils professionnels." />
        <link rel="canonical" href="https://mon-depannage-informatique.fr/blog" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Blog Dépannage Informatique - Guides et Conseils | Excellence Informatique" />
        <meta property="og:description" content="Articles experts sur le dépannage informatique, la formation et l'assistance technique à Nantes." />
        <meta property="og:url" content="https://mon-depannage-informatique.fr/blog" />
        <meta property="og:type" content="website" />
      </Helmet>
      
      <div style={{
        minHeight: '100vh',
        backgroundColor: '#ffffff',
        color: '#1f2937',
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: 'clamp(1rem, 4vw, 2rem)'
        }}>
          {/* Titre de la page */}
          <div style={{
            textAlign: 'center',
            marginBottom: 'clamp(2rem, 5vw, 3rem)',
            paddingBottom: 'clamp(1.5rem, 4vw, 2rem)',
            borderBottom: '2px solid #e5e7eb'
          }}>
            <h1 style={{
              fontSize: 'clamp(2rem, 6vw, 2.5rem)',
              fontWeight: '800',
              lineHeight: '1.25',
              color: '#1f2937',
              margin: '0 0 clamp(1rem, 3vw, 1.5rem) 0',
              fontFamily: "'Inter', 'Poppins', sans-serif"
            }}>
              🧙‍♂️ Blog Excellence Informatique
            </h1>
            <p style={{
              fontSize: 'clamp(1rem, 3vw, 1.25rem)',
              color: '#6b7280',
              maxWidth: '600px',
              margin: '0 auto',
              lineHeight: '1.6'
            }}>
              Découvrez nos derniers articles sur le dépannage informatique, la formation et l'assistance technique
            </p>
          </div>

          {/* Grille des articles */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
            gap: 'clamp(1.5rem, 4vw, 2rem)',
            marginBottom: 'clamp(3rem, 6vw, 4rem)'
          }}>
            {blogPosts.map((article) => (
              <Link
                key={article.id}
                to={`/blog/${article.id}`}
                style={{
                  textDecoration: 'none',
                  color: 'inherit',
                  display: 'block'
                }}
              >
                <div style={{
                  backgroundColor: '#ffffff',
                  border: '1px solid #e5e7eb',
                  borderRadius: '1rem',
                  overflow: 'hidden',
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow = '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)';
                }}
                >
                  <div style={{
                    position: 'relative',
                    height: '200px',
                    overflow: 'hidden'
                  }}>
                    <img
                      src={article.image}
                      alt={article.title}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        transition: 'transform 0.3s ease'
                      }}
                      onError={(e) => {
                        e.target.src = 'https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?w=600&h=300&fit=crop&crop=center';
                      }}
                    />
                    <div style={{
                      position: 'absolute',
                      top: '1rem',
                      left: '1rem'
                    }}>
                      <span style={{
                        backgroundColor: '#3b82f6',
                        color: '#ffffff',
                        fontSize: '0.75rem',
                        fontWeight: '600',
                        padding: '0.5rem 1rem',
                        borderRadius: '0.5rem',
                        border: 'none'
                      }}>
                        {article.category}
                      </span>
                    </div>
                  </div>
                  <div style={{
                    padding: '1.5rem'
                  }}>
                    <h3 style={{
                      fontSize: '1.25rem',
                      fontWeight: '700',
                      lineHeight: '1.4',
                      color: '#1f2937',
                      margin: '0 0 0.75rem 0',
                      fontFamily: "'Inter', sans-serif"
                    }}>
                      {article.title}
                    </h3>
                    <p style={{
                      color: '#6b7280',
                      fontSize: '0.875rem',
                      lineHeight: '1.6',
                      margin: '0 0 1rem 0',
                      display: '-webkit-box',
                      WebkitLineClamp: 3,
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden'
                    }}>
                      {article.description}
                    </p>
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      fontSize: '0.75rem',
                      color: '#9ca3af'
                    }}>
                      <span style={{
                        fontWeight: '500',
                        color: '#3b82f6'
                      }}>
                        {article.author}
                      </span>
                      <span>
                        {article.readingTime}
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          {/* Call to Action */}
          <div style={{
            background: 'linear-gradient(135deg, #3b82f6, #8b5cf6)',
            borderRadius: '1rem',
            padding: 'clamp(2rem, 5vw, 3rem)',
            textAlign: 'center',
            color: '#ffffff'
          }}>
            <h2 style={{
              fontSize: 'clamp(1.5rem, 4vw, 2rem)',
              fontWeight: '700',
              margin: '0 0 1rem 0'
            }}>
              📧 Besoin d'aide informatique ?
            </h2>
            <p style={{
              fontSize: 'clamp(1rem, 3vw, 1.125rem)',
              margin: '0 0 2rem 0',
              opacity: '0.9',
              lineHeight: '1.6'
            }}>
              Contactez-nous pour un dépannage informatique à domicile à Nantes
            </p>
            <Link 
              to="/"
              style={{
                backgroundColor: '#ffffff',
                color: '#3b82f6',
                fontWeight: '600',
                padding: '0.75rem 2rem',
                borderRadius: '0.5rem',
                textDecoration: 'none',
                display: 'inline-block',
                transition: 'all 0.3s ease',
                fontSize: '1rem'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#f3f4f6';
                e.currentTarget.style.transform = 'translateY(-2px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#ffffff';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              Contactez-nous
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogPage;
